import actions from './oktaUsers.actions'
import mutations from './oktaUsers.mutations'

const state = {
  oktaUser: null, //means no user selected, false means not found, or an object if user was found
  oktaUserHistory: []
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
